import { Address } from "../Catalog/Address";

export class ProductDataSource {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public type: string,
    public alternativeNames: string[] = [],
    public kreditorNr: string,
    public contactPerson: string,
    public supportTel: string,
    public supportMail: string,
    public supportWebsite: string,
    public website: string,
    public addressObj: Address,
    public address: string,
    public countryCode: string,
    public brandName: string,
    public additionalInformation: string,
    public logoFile: string,
    public warrantyPages: string,
    public importerName: string,
    public importerAddress: Address,
    public importerCountryCode: string,
    public importerWebsite: string,
    public salesContact: string,
    public salesSupportWebsite: string,
    public salesMail: string,
    public salesTel: string,
    public seoMetaTitle: string,
    public seoMetaDescription: string,
    public gpsrValuesSetByProduct: boolean = false,
    public lastUpdate: Date,
    public lastSync: Date,
  ) { }

  public static GetEmptyProductDataSource() : ProductDataSource {
    return new ProductDataSource("", "", "", "", [],
      "", "", "", "", "",
      "", new Address(), "", "", "", "", "", "", "", new Address(), "", "",
      "", "", "", "", "", "", false, new Date(), new Date());
  }
}
